export default "__VITE_ASSET__CXG36hLy__"